import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvent } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const containerStyle = {
  width: '100%',
  height: '350px',
  borderRadius: '10px',
  overflow: 'hidden',
  position: 'relative' as const,
};

interface GoogleMapComponentProps {
  latitude: number;
  longitude: number;
  destinationName: string;
}

const MapClickHandler: React.FC<{ destinationName: string }> = ({ destinationName }) => {
  useMapEvent('click', () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destinationName)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  });
  return null;
};

const GoogleMapComponent: React.FC<GoogleMapComponentProps> = ({
  latitude,
  longitude,
  destinationName,
}) => {
  const position: [number, number] = [latitude, longitude];
  const [overlayVisible, setOverlayVisible] = useState(true);

  const handleActivate = () => {
    setOverlayVisible(false); // ukryj warstwę blokującą
  };

  const handleMarkerClick = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destinationName)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={containerStyle}>
    {overlayVisible && (
      <div
        onClick={handleActivate}
        style={{
          position: 'absolute',
          zIndex: 999,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.4)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          cursor: 'pointer',
          
        }}
      >
        Kliknij, aby aktywować mapę
      </div>
    )}
      <MapContainer
        center={position}
        zoom={15}
        style={{ width: '100%', height: '100%' }}
        attributionControl={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        <Marker position={position} eventHandlers={{ click: handleMarkerClick }}>
          <Popup>{destinationName}</Popup>
        </Marker>
        <MapClickHandler destinationName={destinationName} />
      </MapContainer>
    </div>
  );
};

export default GoogleMapComponent;
